import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // or whatever storage you are using
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import reducer from '../reducers';
import history from '../web/history';

const { locale, auth, user } = reducer;

const localePersistConfig = {
  key: 'locale',
  storage,
};

const authPersistConfig = {
  key: 'auth',
  storage,
};

const userPersistConfig = {
  key: 'user',
  storage,
};

const rootReducer = combineReducers({
  ...reducer,
  locale: persistReducer(localePersistConfig, locale),
  auth: persistReducer(authPersistConfig, auth),
  user: persistReducer(userPersistConfig, user),
});

const enhancers = [];

let middleware = [thunk, routerMiddleware(history)];
// let middlewareApply;

if (process.env.NODE_ENV === 'development') {
  const { devToolsExtension } = window;
  middleware = [...middleware, logger];

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

export default function configureStore(initialState = {}) {
  const store = createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers),
  );
  const persistor = persistStore(store);
  return { store, persistor };
}
